<ng-container *ngIf="data || dataLinkName?.name || dataLinkName?.id; then dataTmpl; else emptyTmpl"></ng-container>

<ng-template #dataTmpl>
  <span class="c-field-value c-field-value--view-mode">
    <div *rbac="settings.rbacViewProp" class="c-field-value__icon" (click)="openQuickViewModal()">
      <p500-ui-icon name="eye"></p500-ui-icon>
    </div>
    <ng-container *rbac="rbacProperty; then linkRbac; else notRbac"></ng-container>
  </span>

  <ng-template #linkRbac>
    <gtd-ui-field-default-link
      *ngIf="dataLinkName; else default"
      [link]="link"
      [displayData]="dataLinkName?.name"
      [relationData]="dataLinkName?.id"
      [rbacProperty]="rbacProperty"
    ></gtd-ui-field-default-link>
    <ng-template #default>
      <a class="c-field-value__text -link -primary" [routerLink]="link">
        {{ data }}
      </a>
    </ng-template>
  </ng-template>

  <ng-template #notRbac>
    <gtd-ui-field-default-string-or-empty [data]="data || dataLinkName?.name"></gtd-ui-field-default-string-or-empty>
  </ng-template>
</ng-template>

<ng-template #emptyTmpl>
  <gtd-ui-field-empty-component></gtd-ui-field-empty-component>
</ng-template>
